import script from "./DualListSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DualListSelector.vue?vue&type=script&setup=true&lang=js"

import "./DualListSelector.vue?vue&type=style&index=0&id=2c6efec2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6efec2"]])

export default __exports__